import { render } from "./gr_student.vue?vue&type=template&id=160482e0"
import script from "./gr_student.vue?vue&type=script&lang=js"
export * from "./gr_student.vue?vue&type=script&lang=js"

import "./gr_student.vue?vue&type=style&index=0&id=160482e0&lang=css"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__